<template>
  <el-image @click="getVerifyImg" :src="verifyCodeUrl" />
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import { getVerify } from './request/index';

// props
const props = defineProps({
});
// emit
const emit = defineEmits([
  'randomNumberChange',
]);

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  getVerifyImg();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

let verifyCodeUrl = ref(null);
const getVerifyImg = ()=>{
  emit('randomNumberChange', Math.random(), (randomNumber)=>{
    getVerify({
      randomNumber: randomNumber,
    }).then(res=>{
      verifyCodeUrl.value = window.URL.createObjectURL(new Blob([res.data],{type: "image/png"}));
    }).catch(err=>{
      console.log(err);
    });
  });
}

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.el-image{
  height: 100%;
  width: auto;
  cursor: pointer;
  img{
    height: 100%;
    width: 100%;
  }
}
</style>